import { useCallback } from 'react';

interface ToString {
  toString(): string;
}

export function useCopy<T extends ToString>(value: T) {
  return useCallback(() => {
    navigator.clipboard.writeText(value.toString());
  }, [value]);
}
